// extracted by extract-css-chunks-webpack-plugin
module.exports = {"animateIn":"fAmJF","slideInFromBottom":"u-TqA","animateOut":"ZNO1x","slideOutFromTop":"_2-eAG"};